import {Component, Input} from '@angular/core';
import {NavParams} from "ionic-angular";
import moment from "moment";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";

/**
 * Generated class for the AdvertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'loyalty',
    templateUrl: 'loyalty.html'
})
export class LoyaltyComponent {

    @Input() currencySymbol;
    @Input() booking;

    constructor(
      public bookingProvider: BookingServiceProvider
    ){

    }

    ngOnInit(){

    }

}



// WEBPACK FOOTER //
// ./src/components/loyalty/loyalty.ts